module.exports = __webpack_public_path__ + "img/stock0.7b1682df.png";